import { InputLabel } from '@mui/material';
import React from 'react';
import NotFound from './404.png'
import { FlatButton } from 'src/framework/components/buttons/FlatButton';

class NotFoundPage extends React.Component{
    render(){
        return <div>
            <img style={{ width: "38vw", }} src={NotFound} alt="Page not foud" />
            <p style={{textAlign:"center"}}>
              <InputLabel>
                <strong>Algo deu errado :(</strong>
              </InputLabel>
              <p>
                <strong>Esta página não existe ou o link está errado.</strong>
              </p>
              <br />

              <FlatButton
                    text="Voltar"
                    size="small"
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      window.history.back()
                    }}
                  />

            </p>
          </div>;
    }
}
export { NotFoundPage };